// Phase 2.0.1 — Edit Template in Studio.
// Thin wrapper that fetches a template by id and hands it to the existing
// InvitationEditor with `editorMode="template"`. Saves go to
// PUT /api/templates/{id}/content. Event-only UI (publish, share preview,
// snapshots, review note, languages) is hidden inside the editor when
// `isTemplateMode === true`.
//
// Route: /studio/templates/:templateId/edit

import React, { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import InvitationEditor from './InvitationEditor';

const API = process.env.REACT_APP_BACKEND_URL;

export default function TemplateEditorPage() {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/api/templates/${templateId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setTemplate(r.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Template not found');
      navigate('/studio/templates');
    } finally {
      setLoading(false);
    }
  }, [templateId, navigate]);

  useEffect(() => { load(); }, [load]);

  if (loading || !template) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950"
        data-testid="template-editor-loading"
      >
        <Loader2 className="w-5 h-5 animate-spin text-gray-400" />
      </div>
    );
  }

  return (
    <InvitationEditor
      editorMode="template"
      templateId={templateId}
      initialTemplate={template}
    />
  );
}
